import React from "react";

const Loader = () => (
  <div>
    <div>loading...</div>
  </div>
);
export default Loader;
